import type { Playlist, PlaylistItem } from '../../types/playlist';
import { useConfigStore } from '../stores/ConfigStore';

import { formatDurationTag, formatVideoSchedule } from './formatting';

const isFlagExplicitlyFalse = (customConfig: Record<string, unknown>, flagName: string): boolean => {
  if (!Object.prototype.hasOwnProperty.call(customConfig, flagName)) {
    return false;
  }

  const value = customConfig[flagName];
  return value === false || value === 'false' || value === 0 || value === '0';
};

export const createVideoMetadata = (media: PlaylistItem, episodesLabel?: string, isLiveChannel?: boolean) => {
  const { config } = useConfigStore.getState();
  const customConfig = config?.custom || {};
  const metaData = [];
  const duration = formatDurationTag(media.duration);
  const hideCreatedDate = isFlagExplicitlyFalse(customConfig, 'isDisplayCreatedDate');
  const hideEpisodeNumbers = isFlagExplicitlyFalse(customConfig, 'isDisplayEpisodeNumbers');

  if (media.pubdate && !isLiveChannel && !hideCreatedDate) metaData.push(String(new Date(media.pubdate * 1000).getFullYear()));
  if (!episodesLabel && duration) metaData.push(duration);
  if (episodesLabel && !hideEpisodeNumbers) metaData.push(episodesLabel);

  // if (media.genre) metaData.push(media.genre);
  if (media.rating) metaData.push(media.rating);

  return metaData;
};
export const createVideoGenreMetadata = (media: PlaylistItem) => {
  let metaData: string[] = [];
  if (media.genre) metaData = media.genre.split(',');
  return metaData;
};
export const createPlaylistMetadata = (playlist: Playlist, episodesLabel?: string) => {
  const metaData = [];

  if (episodesLabel) metaData.push(episodesLabel);
  if (playlist.genre) metaData.push(playlist.genre as string);
  if (playlist.rating) metaData.push(playlist.rating as string);

  return metaData;
};
export const createLiveEventMetadata = (media: PlaylistItem, locale: string) => {
  const metaData = [];
  const scheduled = formatVideoSchedule(locale, media.scheduledStart, media.scheduledEnd);
  const duration = formatDurationTag(media.duration);

  if (scheduled) metaData.push(scheduled);
  if (duration) metaData.push(duration);
  if (media.genre) metaData.push(media.genre);
  if (media.rating) metaData.push(media.rating);

  return metaData;
};
